import {useContext} from "react"
import {StoreContext} from "index"
import {DashboardStore} from "./dashboard/DashboardStore"
import {EnvironmentStore} from "store/env/EnvironmentStore"
import {AdminStore} from "store/admin/admin.store"


export class RootStore {
    dashboardStore: DashboardStore
    envStore: EnvironmentStore
    adminStore: AdminStore

    constructor() {
        this.dashboardStore = new DashboardStore(this)
        this.envStore = new EnvironmentStore(this)
        this.adminStore = new AdminStore(this)
    }
}

export const rootStore = new RootStore()
export const useRootStore = () => {
    return useContext(StoreContext)
}

